import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { timeout, tap } from 'rxjs/operators';
import { LabMDM } from '../masterdata/models/lab';
import { BBResponseContainer } from '../common-services/response-container';
import { NGSPrintRequest } from './ngs-print-request';

/**
 * Service Class to call backend for print operation
 */
@Injectable()
export class PrintPlateLabelService {

  // Default timeout period for the request
  defaultTimeout = 11000 ;

  // Endpoint for printing barcodes
  readonly PRINT_LABELS = 'print/labels';

  constructor(private http: HttpClient) {
  }

  /**
   * Method that makes the call to back end and returns response
   * @param ngsPrintRequest
   */
  printPlateLabelBarcodes(ngsPrintRequest: NGSPrintRequest): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_LIB_PREP_URL + this.PRINT_LABELS + '/plate';
    return this.http.post<BBResponseContainer>(url, ngsPrintRequest).pipe(timeout(this.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  printWorkListLabels(ngsPrintRequest: NGSPrintRequest): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_LIB_PREP_URL + this.PRINT_LABELS + '/worklist';
    return this.http.post<BBResponseContainer>(url, ngsPrintRequest).pipe(timeout(this.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  //Gets a list of printers
  getPrintersList(lab: LabMDM, active: boolean): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + "admin/mdm/printer";
    let requestParam = new HttpParams().set('labId', lab._id).set('active', active.toString());
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
        error.url = url;
    }));
}

printPlateWorkListLabels(ngsPrintRequest: NGSPrintRequest): Observable<BBResponseContainer> {
  let url = environment.BB_NGS_LIB_PREP_URL + this.PRINT_LABELS + '/plateBarcode';
  return this.http.post<BBResponseContainer>(url, ngsPrintRequest).pipe(timeout(this.defaultTimeout),tap(event => error => {
    error.url = url;
  }));
}

}
